<div class="search-cards-container" *ngIf="(globalContext$ | async) as globalContext">

  <div class="search-form">
    <mat-form-field class="w-100-p">
      <mat-label>Emails</mat-label>
      <textarea [formControl]="batchUserSelectedEmails" matInput style="height:120px;min-height:100px"></textarea>
    </mat-form-field>
    <pre *ngIf="globalContext.debugMode">{{emailSelected}}</pre>

    <div class="search-actions">
      <span class="flex-grow"></span>
      <button [disabled]="emailSelected.length===0" mat-raised-button class="search-button" (click)="doSearch()">
        Search
      </button>
    </div>
  </div>

  <div *ngIf="isSearching" class="search-content flex-center">
    <div>
      [searching....]
    </div>
  </div>
  <div *ngIf="!isSearching && localSearchResult.length === 0" class="search-content flex-center">
    <div>
      [No result]
    </div>
  </div>

  <div *ngIf="!isSearching" class="search-results">

    <div class="p-16" *ngFor="let result of localSearchResult">

      <mat-card class="list-item-card mb-8" [ngClass]="{'card-error': result.result.status !== 'COMPLETE'}">
        <mat-card-header>
          <mat-card-title>{{result.result?.recipient?.email || result.params.email}}</mat-card-title>
          <mat-card-subtitle *ngIf="result.result?.createdAt">{{result.result.createdAt | date:
            'short'}}</mat-card-subtitle>
          <mat-card-subtitle *ngIf="!result.result.createdAt">{{result.result.timestamp | date:
            'short'}}</mat-card-subtitle>
          <span appFlex="grow"></span>
          <h2>{{result?.result?.status || 'ERROR'}}</h2>
        </mat-card-header>

        <mat-card-content *ngIf="result.result.status === 'COMPLETE'">

          <div appFlexLayout="column">
            <div appFlex>
              <h2>Reward : {{result.result.rewardName}} / {{result.result.denomination.value}}
                {{result.result.denomination.currencyCode}}</h2>
            </div>

            <div appFlex>
              <app-url-placeholder [url]="result.result.reward.credentials['Redemption Link']"></app-url-placeholder>
            </div>

          </div>

        </mat-card-content>

        <mat-card-content *ngIf="result.result.status !== 'COMPLETE'">

          <h2>{{result.result.httpCode}} - {{result.result.httpPhrase}}</h2>

          <div class="message-box error" *ngFor="let error of result.result.errors">
            {{error.path}} / {{error.message}}
          </div>

        </mat-card-content>

        <mat-accordion>
          <mat-expansion-panel *ngIf="result.result.status == 'COMPLETE'" [expanded]="false">
            <mat-expansion-panel-header>
              <mat-panel-title>
                Email received : {{result.result.emailSubject}}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
              <h5>From: {{result.result.sender.firstName}} ({{result.result.sender.email}})</h5>
              <div [innerHTML]="result.result.message | safeHtml"></div>
            </ng-template>
          </mat-expansion-panel>

          <mat-expansion-panel [expanded]="false">
            <mat-expansion-panel-header>
              <mat-panel-title>
                Details
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
              <pre>{{result | json}}</pre>
            </ng-template>
          </mat-expansion-panel>
        </mat-accordion>

      </mat-card>

    </div>


  </div>

</div>
